import axios from 'axios'

import { API_URL } from '@/shared/lib/const/env'

export const $axios = axios.create({
	baseURL: API_URL,
	withCredentials: true,
	headers: {
		'Content-Type': 'multipart/form-data'
	}
})
